import Vue from 'vue';
import policyList from '../../components/insurance/insurance-table.vue';
import toGuaranteeSlipDetail from '../../components/insurance/guaranteeSlip-detail.vue';
import commonVideo from '../../components/console-common/common-video.vue';
import { toYuan } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'applyLoan',
    components: {
        'dfs-guarantee-slip-detail': toGuaranteeSlipDetail,
        'dfs-policy-list': policyList,
        'el-common-video': commonVideo,
    },
    computed: {
        repeatPolicy: function () {
            return this.$route.params.repeatPolicy || [];
        },
    },
    created: function () { },
    data: function () {
        var _this = this;
        return {
            propData: {
                isShowDetail: false,
                url: 'proxy/api/policy/info',
                method: 'post',
                data: {
                    insPolicyCode: '',
                    insCompanyCode: '',
                },
            },
            queryModelData: {
                titleLeft: '可申请车险贴心宝贷款的保单',
                table: {
                    type: true,
                    tableTitle: [
                        {
                            label: '保单号',
                            align: 'left',
                            prop: 'insPolicyCode',
                            minWidth: '160px',
                        },
                        {
                            label: '保费(元)',
                            align: 'right',
                            prop: 'premium',
                            width: '120px',
                            formatter: function (value) {
                                return toYuan(value.premium).toFixed(2);
                            },
                        },
                        {
                            label: '批贷金额(元)',
                            align: 'right',
                            prop: 'loanAmount',
                            width: '120px',
                            formatter: function (value) {
                                return toYuan(value.loanAmount).toFixed(2);
                            },
                        },
                        {
                            label: '保险公司',
                            align: 'left',
                            prop: 'insCompanyName',
                            width: '230px',
                        },
                        {
                            label: '被保人',
                            align: 'left',
                            prop: 'insuredName',
                            minWidth: '100px',
                            width: '230px',
                        },
                        {
                            label: '车牌号',
                            align: 'left',
                            prop: 'plateNumber',
                            minWidth: '110px',
                        },
                        {
                            label: '保单起期',
                            align: 'left',
                            prop: 'startTime',
                            minWidth: '180px',
                        },
                        {
                            label: '保单止期',
                            align: 'left',
                            prop: 'endTime',
                            minWidth: '180px',
                        },
                        {
                            label: '签单日期',
                            align: 'left',
                            prop: 'signTime',
                            minWidth: '180px',
                        },
                        {
                            label: '操作',
                            align: 'center',
                            minWidth: '112px',
                            fixed: 'right',
                            buttons: [
                                {
                                    buttonName: '查看',
                                    poper: false,
                                    callback: function (row) {
                                        _this.toGuaranteeSlipDetail(row);
                                    },
                                },
                            ],
                        },
                    ],
                    sourceUrl: '/proxy/api/policy/applicable/list',
                },
            },
        };
    },
    methods: {
        toGuaranteeSlipDetail: function (row) {
            var insPolicyCode = row.insPolicyCode, insCompanyCode = row.insCompanyCode;
            this.propData.data.insPolicyCode = insPolicyCode;
            this.propData.data.insCompanyCode = insCompanyCode;
            this.propData.isShowDetail = true;
        },
        closeDetail: function () {
            this.propData.isShowDetail = false;
            this.propData.data.insPolicyCode = '';
            this.propData.data.insCompanyCode = '';
        },
    },
});
